export default __webpack_public_path__ + "static/media/Banner2_revamp_Cn.98c3aaed.webp";